// src/components/common/PageLoader.js
import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { ThemeContext } from '../../context/ThemeContext';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 3rem 0;
`;

const Spinner = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
`;

const PageLoader = () => {
  const { theme } = useContext(ThemeContext);
  
  return (
    <LoaderContainer>
      <Spinner>
        <svg width="60" height="60" viewBox="0 0 60 60">
          <circle 
            cx="30" 
            cy="30" 
            r="25" 
            fill="none" 
            stroke={theme.primary} 
            strokeWidth="4" 
            strokeLinecap="round"
          >
            <animateTransform 
              attributeName="transform" 
              type="rotate" 
              from="0 30 30" 
              to="360 30 30" 
              dur="1.5s" 
              repeatCount="indefinite"
            />
            <animate 
              attributeName="stroke-dasharray" 
              from="1, 150" 
              to="90, 150" 
              dur="1.5s" 
              repeatCount="indefinite"
            />
            <animate 
              attributeName="stroke-dashoffset" 
              from="0" 
              to="-35" 
              dur="1.5s" 
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </Spinner>
    </LoaderContainer>
  );
};

export default PageLoader;